import './storagePrefix'; // must run before any module touches storage (UK path build)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
// Global design tokens (light theme). Imported after bootstrap so our
// CSS custom properties / utilities take precedence. Source of truth
// for colours, typography, spacing — see src/Constants/Colors.js.
import './styles/theme.css';
// Global light-theme overrides for portal-rendered components (modals)
// that scoped rules can't reach.
import './styles/global-overrides.theme.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// StrictMode deliberately double-invokes effects in development, so every
// mount fires its data-fetching effects twice — on pages like TPCRM Analytics
// that is six requests instead of three, which reads as the app being slow
// while working locally. Skip it for REACT_APP_ENV=dev and keep it everywhere
// else, so stag / prod / uk builds still get the extra checks.
//
// Note: the npm start script hardcodes REACT_APP_ENV='dev' before dotenv runs,
// so a local dev server always takes the non-strict branch regardless of what
// .env says.
if (process.env.REACT_APP_ENV === 'dev') {
  root.render(<App />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
